import React from 'react';
import PropTypes from 'prop-types';
import Button from "UI/Button";

import FacebookPanel from "./FacebookPanel";
import TwitterPanel from "./TwitterPanel";
import ChooseIntegrationPanel from "./ChooseIntegrationPanel";
import Modal from "UI/Modal";

const initialState = {
    history: []
};

export default class ChooseNewIntegrationDialog extends React.Component
{
    state = initialState;

    static propTypes = {
        open: PropTypes.bool.isRequired,
        onClose: PropTypes.func.isRequired,
    };

    stageMap = {
        'facebook': FacebookPanel,
        'twitter': TwitterPanel,
        undefined: ChooseIntegrationPanel,
    };

    next = stage => this.setState({history: [...this.state.history, stage]});

    prev = () => this.setState({history: this.state.history.slice(0, -1)});

    onClose = () => {
        this.setState(initialState, () => {
            this.props.onClose();
        });
    };

    render()
    {
        const { history } = this.state;

        const { open } = this.props;

        const Panel = this.stageMap[history.slice(-1)[0]];

        return <Modal open={open} onClose={this.onClose} className="w-full max-w-xl">
            <Modal.Header>
                New Integration
            </Modal.Header>
            <Modal.Content>
                <Panel next={this.next} />
            </Modal.Content>
            <Modal.Footer>
                <ChooseNewIntegrationActions close={this.onClose} prev={this.prev} history={history} />
            </Modal.Footer>
        </Modal>;
    }
}

class ChooseNewIntegrationActions extends React.Component
{
    static propTypes = {
        close: PropTypes.func.isRequired,
        prev: PropTypes.func.isRequired,
        history: PropTypes.array.isRequired
    };

    render()
    {
        return <>
            {
                this.props.history.length > 0 &&
                <Button onClick={this.props.prev}>Back</Button>
            }
            <Button onClick={this.props.close}>Cancel</Button>
        </>;
    }
}

